import { IUser } from '../../../interfaces/User.interfaces';
import { customAxios } from '../../common/customAxios';

export const getUsersMe = (): Promise<IUser> => {
  return customAxios.get('/users/me');
};
